<template>
  <div>
    <!-- 导航栏 - S -->
    <nav class="ct-header navbar navbar-default navbar-fixed-top">  <!--glyphicon glyphicon-menu-hamburger -->
      <div class="header_left_img">
        <!-- <img src="../assets/images/index/header_bg.png" class="headerleftimg"/> -->
        <div class="containers">
          <div class="item_hender_content">
            <div class="item_header"><i class="icon iconfont icondianhua"></i><span>(+852) 3100 0477</span></div>
            <div class="item_header"><i class="icon iconfont iconchuanzhen"></i><span>(+852) 3102 0345</span></div>
            <div class="item_header"><i class="icon iconfont iconyoujian"></i><span style="margin-left:2px;">info@hkmedilab.com</span></div>
          </div>
        </div>
      </div>
      <!-- <div class="header-logo">
        <div class="header_bg_second">
          <router-link to="/home" class="router_header">
            <img src="../assets/images/logo_header.png" class="logo-header"/>
          </router-link>
        </div>
      </div> -->
      <div class="hearder_left">
        <div class="container_upper">
          <div class="logo_router">
            <router-link to="/home" class="router_header">
              <img src="../assets/images/logo_header.png" class="logo-header"/>
            </router-link>
          </div>
          <div class="ct-content">
            <div class="href-ul">
              <ul class="nav nav-pills" @mouseleave="leave()">
                <!-- <li @mouseenter="mouseenter('aboutCompany')">
                  <a  class="dropdrow_a">{{$t('NavabarText.navbar_about')}}</a>
                  <div  class="dropdown" v-if="dropdownIndex=='aboutCompany'">
                    <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'" >
                      <li @click="liJump('aboutUs')">{{$t('ContractText.aboutzhouxin')}}</li>
                      <li @click="liJump('technology')">{{$t('ContractText.technology')}}</li>
                      <li @click="liJump('accreditation')" style="line-height:20px;!important">{{$t('ContractText.qualification')}}</li>
                      <li @click="liJump('media')">{{$t('ContractText.mediacenter')}}</li>
                      <li @click="liJump('partnership')">{{$t('ContractText.cooperation')}}</li>
                      <li @click="liJump('career')">{{$t('ContractText.recruitment')}}</li>
                    </ul>
                  </div>
                </li> -->
                <li>
                  <a class="dropdrow_a" @click="handleTabsClick('home')" :class="active=='home'?'active':''">{{$t('NavabarText.navbar_home')}}</a>
                </li>
                <li @mouseenter="mouseenter('item')" @mouseleave="leaveSecond()">
                  <a class="dropdrow_a" @click="handleTabsClick('about')" :class="active=='about'?'active':''">{{$t('NavabarText.navbar_about')}}</a>
                  <div class="dropdown" :class="$store.state.lang!='en-US'?'':'dropdown_special'"
                       v-if="dropdownIndex=='item'||dropdownSecondIndex=='health'||dropdownSecondIndex=='cancer'||dropdownSecondIndex=='diseases'||dropdownSecondIndex=='risk'">
                    <ul :class="$store.state.lang!='en-US'?'':'dropdown_second_special_three'">
                      <li @click="liJump('about?to=id_company_info', 'about')">
                        <span>{{$t('About_Navbar.Company')}}</span>
                        <!-- <div class="second-ul" :class="$store.state.lang!='en-US'?'':'second_ul_special'"  @click="liJump('reproductinvhealth')">
                            <span >{{$t('About_Navbar.Company')}} </span><i class="icon iconfont iconxiangyou xiangyou"></i>
                        </div>
                        <div class="dropdown-second" :class="$store.state.lang!='en-US'?'':'dropdown_second_special'" v-if="dropdownSecondIndex=='health'">
                          <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'">
                            <li @click="liJump('Company')">{{$t('About_Navbar.Company')}}</li>
                            <li @click="liJump('Horor')">{{$t('About_Navbar.Horor')}}</li>
                            <li @click="liJump('Technology')">{{$t('About_Navbar.Technology')}}</li>
                            <li @click="liJump('Team')">{{$t('About_Navbar.Team')}}</li>
                          </ul>
                        </div> -->
                      </li>
                      <li @click="liJump('home?to=id_honor', 'home')" class="second-div">
                        <span>{{$t('About_Navbar.Horor')}}</span>
                        <!-- <div class="second-ul" :class="$store.state.lang!='en-US'?'':'second_ul_special'" @click="liJump('cancerdescript')">
                            <span>{{$t('About_Navbar.Horor')}}</span>
                        </div>
                        <div class="dropdown-second" :class="$store.state.lang!='en-US'?'':'dropdown_second_special_two'" v-if="dropdownSecondIndex=='cancer'">
                          <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'">
                            <li @click="liJump('genetictumordetection')">{{$t('ContractText.Genetic_tumor_detection')}}</li>
                            <li @click="liJump('cancerrealtime')">{{$t('ContractText.Cancer_real_time_monitoring')}}</li>
                          </ul>
                        </div> -->
                      </li>
                      <li @click="liJump('home?to=id_technology', 'home')" class="second-div">
                        <span>{{$t('About_Navbar.Technology')}}</span>
                        <!-- <div class="second-ul" :class="$store.state.lang!='en-US'?'':'second_ul_special'" @click="liJump('infectiousdisease')">
                          <span>{{$t('About_Navbar.Technology')}}</span>
                        </div>
                        <div class="dropdown-second" :class="$store.state.lang!='en-US'?'':'dropdown_second_special_two'" v-if="dropdownSecondIndex=='diseases'">
                          <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'">
                            <li @click="liJump('vaccinetest')">{{$t('ContractText.Vaccine_antibody_test')}}</li>
                            <li @click="liJump('stdfastces')">{{$t('ContractText.STD_quick_test')}}</li>
                          </ul>
                        </div> -->
                      </li>
                      <li @click="liJump('about?to=id_team', 'about')" class="second-div">
                        <span>{{$t('About_Navbar.Team')}}</span>
                        <!-- <div class="second-ul"  :class="$store.state.lang!='en-US'?'':'second_ul_special'" @click="liJump('healthylife')">
                            <span>{{$t('About_Navbar.Team')}}</span>
                            <i class="icon iconfont iconxiangyou xiangyou"></i>
                        </div>
                        <div class="dropdown-second" v-if="dropdownSecondIndex=='risk'" >
                          <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'">
                            <li @click="liJump('innategene')">{{$t('ContractText.Talent_gene_testing')}}</li>
                          </ul>
                        </div> -->
                      </li>
                    </ul>
                  </div>
                </li>
                <li @mouseenter="mouseenter('navbar_item')">
                  <a class="dropdrow_a" :class="active=='projects'?'active':''">{{$t('NavabarText.navbar_item')}}</a>
                  <div class="dropdown" v-if="dropdownIndex=='navbar_item'" :class="$store.state.lang!='en-US'?'':'dropdown_special'">
                    <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'">
                      <li @click="liJump('yDNATest', 'projects')">
                        <span>{{$t('Item_NavBar.YC_DNA_Test')}}</span>

                      </li>
                      <li @click="liJump('nPrenatalTest', 'projects')">
                        <span>{{$t('Item_NavBar.Non_Prenatal_Test')}}</span>
                      </li>
                      <li @click="liJump('paternityTest', 'projects')" style="line-height:20px;!important" v-if="$store.state.lang!='en-US'">
                        <span>{{$t('Item_NavBar.Non_Paternity_Test')}}</span>
                      </li>
                      <li @click="liJump('paternityTest', 'projects')" v-if="$store.state.lang=='en-US'"><span>Paternity Test <br> (before birth or after birth)</span></li>
                      <!-- <li @click="liJump('media')">
                        <span>{{$t('Item_NavBar.Prenatal_And_Postpartum')}}</span>
                        </li> -->
                    </ul>
                  </div>
                </li>
                <!-- <li>
                  <a href="/#/gensuniverse" @click="handleTabsClick('gensuniverse')" :class="active=='gensuniverse'?'active':''">{{$t('NavabarText.navbar_newinformation')}}</a>
                </li> -->
                <li @mouseenter="mouseenter('navbr_new')">
                  <a class="dropdrow_a" :class="active=='news'?'active':''">{{$t('NavabarText.navbr_new')}}</a>
                  <div class="dropdown" v-if="dropdownIndex=='navbr_new'" :class="$store.state.lang!='en-US'?'':'dropdown_special'">
                    <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'">
                      <li @click="liJump('Notices', 'news')"><span>{{$t('New_NavBar.Notice')}}</span></li>
                      <li @click="liJump('MediaCenter', 'news')"><span>{{$t('New_NavBar.MediaCentre')}}</span></li>
                    </ul>
                  </div>
                </li>
                <!-- <li>
                  <a href="/#/news" @click="handleTabsClick('news')" :class="active=='news'?'active':''">{{$t('NavabarText.navbr_jiyin')}}</a>
                </li> -->
                <li>
                  <a href="/#/contact" @click="handleTabsClick('contact')" :class="active=='contact'?'active':''">{{$t('NavabarText.navbar_contact')}}</a>
                </li>
              </ul>
            </div>
            <div class="search-tip">
              <a class="search-btn" @click="handleTabsClick('search')">
                {{$t('NavabarText.navbar_search')}}
                <span class="icon iconfont iconsousuo iconfangdajingbeifen"></span>
              </a>
            </div>
            <div class="lang_header">
              <div class="lang-transfer" @click="langChangClick('zh-TCC')">
                <img src="../assets/images/hk.png" class="logo-headers"/>
                <span class="lang">繁</span>
              </div>
              <div class="lang-transfer" @click="langChangClick('zh-CN')">
                <img src="../assets/images/cn.png" class="logo-headers"/>
                <span class="lang">简</span>
              </div>
              <div class="lang-transfer" @click="langChangClick('en-US')">
                <img src="../assets/images/en.png" class="logo-headers"/>
                <span class="lang">Eng</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <!-- 导航栏 - E -->
    <div class="routerview">
      <router-view></router-view>
    </div>

    <web-footer></web-footer>
  </div>
</template>


<script type="text/javascript">
  import WebFooter from "../components/web-footer";
  import Qs from 'Qs'

  export default {
    components: {WebFooter},
    data() {
      return {
        mobileUrl: 'http://m.hkmedilab.com/#/search',//http://m.hkmedilab.com
        langText: this.$store.state.lang == 'en-US' ? 'English | 繁' : '繁 | English',
        active: 'home',
        dropdownIndex: '',
        dropdownSecondIndex: '',
      }
    },
    watch: {
      '$route'() {
        console.log('ssdd', this.$route);
        var routeName = this.$route.name;
        if (routeName == 'cancerdescript' || routeName == 'reproductinvhealth' || routeName == 'infectiousdisease' || routeName == 'healthylife') {
          console.log($(window).scrollTop());
          if ($(window).scrollTop() > 900) {
            $('.navbar-default').addClass('Opactiy');//opactiy=1
            $('.routerview').removeClass('routerviewPadding');
            $('.gens-universe').removeClass('gens_universes');
            $('.gens-universe_cancers').removeClass('gens_universes');
          } else {
            var box_twos = document.querySelector(".Opactiy");
            if (box_twos != null) {
              $('.navbar-default').removeClass('Opactiy');//Opacity=0.5
              $('.gens-universe').removeClass('gens_universes');
              $('.gens-universe_cancers').removeClass('gens_universes');
            }
            $('.navbar-default').addClass('Opactiyszerofive')
            var box_three = document.querySelector(".routerviewPadding");
            if (box_three != null) {
              $('.routerview').removeClass('routerviewPadding');
            }

          }
        } else {
          $('.navbar-default').removeClass('Opactiy');
          $('.navbar-default').removeClass('Opactiyszerofive')
          $('.routerview').addClass('routerviewPadding');
          $('.gens-universe').addClass('gens_universes');
          $('.gens-universe_cancers').addClass('gens_universes');
        }

      }
    },
    mounted() {
      let active = localStorage.getItem('home-tab') || 'home';
      this.active = active;

      var routeName = this.$route.name;
      if (routeName == 'cancerdescript' || routeName == 'reproductinvhealth' || routeName == 'infectiousdisease' || routeName == 'healthylife') {
        console.log($(window).scrollTop());
        if ($(window).scrollTop() > 900) {
          $('.navbar-default').addClass('Opactiy');//opactiy=1
          $('.routerview').removeClass('routerviewPadding');
          $('.gens-universe').removeClass('gens_universes');
          $('.gens-universe_cancers').removeClass('gens_universes');
        } else {
          $('.navbar-default').addClass('Opactiyszerofive')

          var box_twos = document.querySelector(".Opactiy");
          if (box_twos != null) {
            $('.navbar-default').removeClass('Opactiy');//Opacity=0.5
            $('.gens-universe').removeClass('gens_universes');
            $('.gens-universe_cancers').removeClass('gens_universes');
          }
          var box_three = document.querySelector(".routerviewPadding");
          if (box_three != null) {
            $('.routerview').removeClass('routerviewPadding');
          }

        }
      } else {
        $('.navbar-default').removeClass('Opactiy');
        $('.navbar-default').removeClass('Opactiyszerofive')
        $('.routerview').addClass('routerviewPadding');
        $('.gens-universe').addClass('gens_universes');
        $('.gens-universe_cancers').addClass('gens_universes');
      }
      if (this.isMobileDevice() && this.mobileUrl) {//是手机 跳转到手机地址
        window.location.href = this.mobileUrl;
      }

      $(window).scroll(function () { //滚动某位置 动画特效

        var box_two = document.querySelector(".routerview .gens-universe");
        var box_three = document.querySelector(".routerview .gens-universe_cancers");
        var box_four = document.querySelector(".routerview .gens-infectiousdisease");
        var box_five = document.querySelector(".routerview .gens-healthylife");
        if (box_two != null || box_three != null || box_four != null || box_five != null) {
          if ($(window).scrollTop() > 900) {
            $('.navbar-default').addClass('Opactiy');
            $('.navbar-default').removeClass('Opactiyszerofive')
          } else {
            var box_twos = document.querySelector(".Opactiy");
            if (box_twos != null) {
              $('.navbar-default').removeClass('Opactiy');

            }
            $('.navbar-default').addClass('Opactiyszerofive')
          }
        } else {
          $('.navbar-default').addClass('Opactiy');
        }

      })
    },
    methods: {
      isMobileDevice() {
        let isMobile = false;
        let thisOS = navigator.platform,
          userAgent = navigator.userAgent,
          appVersion = navigator.appVersion;
        let os = ["iPhone", "iPod", "iPad", "android", "Nokia", "SymbianOS", "Symbian", "Windows Phone", "Phone", "Linux armv71", "MAUI", "UNTRUSTED/1.0", "Windows CE", "BlackBerry", "IEMobile"];
        for (let i = 0; i < os.length; i++)
          if (thisOS.match(os[i]) || userAgent.match(os[i] || appVersion.match(os[i])))
            isMobile = true;

        //因为相当部分的手机系统不知道信息,这里是做临时性特殊辨认
        if (navigator.platform.indexOf('iPad') != -1)
          isMobile = true;

        //做这一部分是因为Android手机的内核也是Linux
        //但是navigator.platform显示信息不尽相同情况繁多,因此从浏览器下手，即用navigator.appVersion信息做判断
        if (appVersion.match(/linux/i))
        //X11是UC浏览器的平台 ，如果有其他特殊浏览器也可以附加上条件
          if (appVersion.match(/mobile/i) || appVersion.match(/X11/i))
            isMobile = true;

        return isMobile;
      },
      langChangClick(lang) {
        // console.log(this.langText, this.$store.state.lang);
        // if (this.$store.state.lang == 'zh-TCC') {
        //   this.langText = 'English | 繁';
        //   console.log(this.langText);
        //   this.$i18n.locale = 'en-US';
        //   this.$store.commit('setlang', 'en-US');
        // } else {
        //   this.langText = '繁 | English';
        //   this.$store.commit('setlang', 'zh-TCC');
        //   this.$i18n.locale = 'zh-TCC';
        //   console.log(this.langText);
        // }
        this.$store.commit('setlang', lang);
        this.$i18n.locale = lang;
        console.log('this.$i18n.locale', this.$i18n.locale);
      },

      handleTabsClick(name) {
        this.href(name)
        this.tabChaned(name);
      },
      tabChaned(tabName){
        if (tabName) {
          this.active = tabName;
          localStorage.setItem('home-tab', tabName)
        }
      },
      mouseenter(value) {
        this.dropdownIndex = value
      },
      leave() {
        this.dropdownIndex = ''
      },
      mouseenterSecond(value) {
        this.dropdownSecondIndex = value
      },
      leaveSecond() {
        this.dropdownSecondIndex = ''
        this.dropdownIndex = ''
      },
      liJump(path, tabName) {
        this.tabChaned(tabName);

        let cur = this.$route.name;
        if (cur.indexOf(path) !== -1 || path.indexOf(cur) !== -1) {
          let params = Qs.parse(path.substr(path.indexOf('?') + 1));
          //如果使用to锚定, 则所有路由都需要, 不然重复添加相同路由会报错
          if (params.to) {
            this.$nextTick(() => {
              //$(`#${params.to}`).get(0).scrollIntoView();

              let top = $(`#${params.to}`).offset().top;
              top -= $('.navbar').height();
              //$(`html`).scrollTop(top);
              $('html,body').animate({scrollTop: top}, 500);
            })
            return;
          }
        }
        this.$router.push({
          path: path
        })
      },
      href(path) {
        let href = location.protocol + "//" + location.host + "/#/" + path;
        location.href = href;
        location.reload();
      },
      liJumps(path) {
        this.$router.push({
          path: path
        })
      },
    },
  }

</script>

<style lang="scss" scoped>
  @import '../assets/font/iconfont.css';

  .ct-header {
    position: fixed;
    padding: 0px 0;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
    background: #ffffff;
    z-index: 999999;
    margin-bottom: 0;
    height: 7vw;
    box-sizing: border-box;
    // background-image: url('../assets/images/index/header_bg.png');
  }

  .logo-weixin {
    height: auto;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .header-logo {
    width: 630px;
    // padding:20px 0 20px 0;
    height: 68px;
    background-image: url('../assets/images/index/green_left_bg.png');
    // z-index: 99999;
  }

  .header_bg_second {
    width: 630px;
    height: 68px;
    line-height: 68px;
    margin: 0px 20px 0px 0px;
    background-image: url('../assets/images/index/white.png');
  }

  .hearder_left {
    height: 4vw;
    line-height: 4vw;
    width: 85%;
    margin: auto;

    .container_upper {
      margin: auto;
      position: relative;
    }
  }

  .containers {
    width: 85%;
    margin: auto;

  }

  .logo_router {
    float: left;
    z-index: 25;
    width: 21vw;
    background-color: #ffffff;
    margin-top: -13vw;
    padding-top: 13vw;
    position: relative;
  }

  .ct-header .container_upper .logo_router:before {
    position: absolute;
    content: '';
    right: -5vw;
    top: 0px;
    height: 100%;
    width: 10000%;
    background-color: #ffffff;
    -ms-transform: skewX(-25deg);
    -webkit-transform: skewX(-25deg);
    transform: skewX(-25deg);
    border-right: 2px solid #1db9a0;
  }

  .header_left_img {
    height: 3vw;
    width: 100%;
    margin: auto;
    //margin-left:-12px;
    //background-image: linear-gradient(to right, #1DB9A0 0%, #4d94c4 100%);
    background-image: linear-gradient(-90deg,
      #4799bf 0%,
      #32c6ac 100%),
    linear-gradient(
        #ffffff,
        #ffffff);
    background-blend-mode: normal,
    normal;
    background-size: 100% 100%;
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    box-sizing: border-box;

    .item_hender_content {
      display: flex;

      .item_header {
        &:first-child {
          padding-left: 29vw;
        }

        padding-right: 1vw;
        padding-left: 1vw;

        span {
          font-family: AlibabaPuHuiTi-Medium;
          font-size: 0.8vw;
          font-weight: bold;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #ffffff;
        }

        i {
          color: #ffffff;
          font-size: 16px;
          padding-right: 5px;
        }
      }
    }
  }

  .ct-content {
    font-family: 'Microsoft JhengHei', sans-serif !important;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 4vw;
  }

  .search-tip {
    margin-top: 2px;

    .search-btn {
      width: 6vw;
      height: 2vw;
      background-color: #1cbb9f;
      border-radius: 3vw;
      color: #fff;
      padding: 0.6vw 0.8vw;
      border: solid 1px #1cbb9f;
      text-decoration: none;
      cursor: pointer;
      font-family: AlibabaPuHuiTi-Regular;
      font-weight: bold;
      font-size: 16px;
    }

    .iconfangdajingbeifen {
      font-size: 18px;
    }

  }

  .search-tip a:hover {
    background-color: #1cbb9f !important;
    color: #fff;
  }

  .href-ul {
    padding-left: 6.0vw;
  }

  .lang_header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding-left: 1.1vw;
  }

  .lang-transfer {
    padding-left: 0.5vw;
    padding-right: 0.5vw;
    font-family: AlibabaPuHuiTi-Regular;
    font-size: 16px;
    font-stretch: normal;
    font-weight: 500;
    color: #000000;
    cursor: pointer;
  }

  .lang-transfer span:hover {
    //  background-color: #1cbb9f !important;
    color: #1cbb9f !important;
  }

  .navbar-default {
    border-color: #ffffff !important;

  }

  .three-line {
    color: #13abc0;
    font-size: 2.5rem;
  }

  .dropdown-menu {
    min-width: 4rem !important;

  }

  .dropdown ul li {
    margin-right: 0px !important;
  }

  .nav li a {
    display: flex;
    justify-content: center;
    align-items: center;
    // padding: 17px 8px 3px 8px !important;
    font-family: AlibabaPuHuiTi-Regular;
    font-size: 1vw;
    color: #000000;
    text-transform: none;
  }

  .dropdrow_a {
    position: relative;
    cursor: pointer;
  }

  .dropdrow_a:hover {

  }

  .xiala {
    margin-left: 10px;
    font-size: 14px;
  }

  .xiangyou {
    font-size: 12px;
    color: #888;
  }

  .second-ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .dropdown {
    position: absolute;
    //padding:10px 20px;
    background-color: #ffffff;
    border: 2px solid #1cb89d;
    text-align: left;
    min-width: 245px;

    ul {
      list-style: none;
      padding: 0px 0;
      margin: 0;
      line-height: 27px;
      letter-spacing: .07em !important;

      font-family: AlibabaPuHuiTi-Regular;
      font-weight: bold;
      font-size: 16px;

    }

    li {
      padding: 3px 0;
      cursor: pointer;
      padding: 10px 20px;
      color: #3b3b3b;
      position: relative;
      line-height: 25px !important;
      // font-weight: bold;
    }

    //  li:hover{
    //   // color:#13abc0;
    //   background: #1cb89d;
    //   color:#fff;
    // }

  }

  .dropdown_special {

    min-width: 275px;
  }

  .dropdown ul li:hover::before {
    width: 100%;
  }

  .dropdown ul li:hover {
    color: #fff;
  }

  .dropdown ul li:before {
    position: absolute;
    content: '';
    left: 0px;
    top: 0px;
    width: 0px;
    height: 100%;
    color: #fff !important;
    background-color: #1cb89d;
    transition: all 600ms ease;
    -webkit-transition: all 600ms ease;
    -ms-transition: all 600ms ease;
    -o-transition: all 600ms ease;
    -moz-transition: all 600ms ease;
  }

  .dropdown > li:hover {
    color: #ffffff;

    position: relative;
  }

  .dropdown ul li:hover span {
    color: #fff;
    position: relative;
  }

  .second-ul {

  }

  .second_ul_special {
    font-size: 15px !important;
  }

  .second-div {
    position: relative;
    // margin-right:0px !important;
  }

  .dropdown-second {
    display: block;
    position: absolute;
    padding: 10px 20px;
    background-color: #ebfaff;
    left: 100%;
    margin-left: 20px;
    min-width: 225px;
    top: -18px;
    overflow: visible;

    ul {
      list-style: none;
      padding: 7px 0;
      margin: 0;
      line-height: 27px;
      letter-spacing: 0.07em !important;
      color: #3b3b3b;
      // font-weight: 400;
      font-size: 14px;
    }

    li {
      padding: 3px 0;
      cursor: pointer;
      // font-weight: bold;
      font-size: 16px;;
    }

    li:hover {
      color: #13abc0;
    }
  }

  .dropdown_second_special {
    min-width: 250px;
    line-height: 29px !important;

    ul {
      li {
        line-height: 20px;
        margin-top: 10px;

        &:first-child {
          margin-top: 0;
        }
      }
    }
  }

  .dropdown_second_special_two {
    min-width: 330px !important;
  }

  .dropdown_second_special_three {
    min-width: 220px !important;
  }


  .nav li a:hover {
    color: #000000;
  }

  .nav-pills {
    width: 33vw;

    ul li {
      &:last-child {
        padding-right: 0;
      }
    }
  }

  .nav-pills li a {
    border-radius: 0;
    font-weight: bold;
  }

  .nav-pills > li + li {
    margin-left: 0;
  }

  .nav li a {
    color: #000000;
  }

  .nav li a:hover {
    background: #ffffff;
    color: #000000;
  }

  .active {
    background: #fff !important;
    color: #13abc0 !important;
  }

  .Opactiyszerofive .active {
    background: none !important;
  }

  // .nav li a:link{
  //    background: #368da7;
  //   color:#fff;
  // }
  .dropdown-menu li a {
    font-size: 1.2rem;
    letter-spacing: 0rem;
    color: #13abc0;
    // font-weight: bold !important;
  }

  .dropdown-menu li a:active {

    color: #13abc0 !important;
  }

  .logo-header {
    height: auto;
    position: relative;
    display: inline-block;
    max-width: 100%;
    margin-top: -2vw;
    margin-left: -8vw;

  }

  .router_header {

  }

  .logo-headers {
    cursor: pointer;
  }

  .lang {

  }

  .lang:hover {
    // color: #fff !important;
  }

  .routerview {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    min-height: 600px;
    overflow-y: auto;
    left: 0;
    right: 0;


  }


  .Opactiy {
    background: #fff !important;
  }

  .Opactiyszerofive {
    background: rgba(0, 0, 0, 0) !important;

    ul {
      li {
        color: #fff !important;
      }
    }

    a {
      color: #fff !important;
    }

    .lang {
      color: #fff;
    }

    .dropdown {

      ul {

        li {
          color: #000 !important;

        }
      }

      .xiangyou {
        color: #000 !important;
      }
    }
  }

  .routerviewPadding {
    padding: 7vw 0 0 0 !important;
    position: relative;
  }

  .gens_universes {
    margin: 1rem 0 0 0 !important;
  }

  .hearder_left .nav > li {
    padding-left: 3vw;

    &:first-child {
      padding-left: 0;
    }
  }

  @media screen and (max-width: 800px) {
    .hearder_left {
      width: 90%;
    }
    .nav-pills {
      width: 33vw !important;
    }
    .hearder_left .nav>li {
      padding-left: 0.9vw !important;

      &:first-child {
        padding-left: 0 !important;
      }
    }
    .search-tip .search-btn {
      padding: 0.3vw 0.3vw !important;
      font-size: 0.4vw;

      .iconfangdajingbeifen {
        font-size: 0.6vw;
      }
    }
    .lang {
      font-size: 0.6vw;
    }
    .hearder_left .nav li {
      padding-left: 0.9vw !important;
    }
    .href-ul {
      padding-left: 4vw;
    }
    .logo_router {
      float: left;
      z-index: 25;
      width: 13vw;
      background-color: #ffffff;
      margin-top: -10vw;
      padding-top: 10vw;
      position: relative;
    }
    .header_left_img .item_hender_content .item_header:first-child {
      padding-left: 16vw;
    }
  }

  @media screen and (min-width: 800px) and (max-width: 1200px) {
    .nav-pills {
      width: 33vw !important;

      ul li {
        font-size: 1.2vw !important;
      }
    }
    .dropdrow_a {
      font-size: 1.2vw !important;
    }
    .item_header {
      &:first-child {
        padding-left: 28vw !important;
      }

      font-size: 0.5vw !important;
      padding-right: 1vw !important;

      span {
        font-size: 0.5vw !important;
      }
    }
    .hearder_left .nav>li {
      padding-left: 2vw !important;

      &:first-child {
        padding-left: 0 !important;
      }
    }
    .search-tip .search-btn {
      width: 2vw !important;

    }

    .logo_router {
      float: left;
      z-index: 25;
      width: 16vw;
      background-color: #ffffff;
      margin-top: -10vw;
      padding-top: 10vw;
      position: relative;
    }

  }

  @media screen and (min-width: 1200px) and (max-width: 1320px) {
    .nav-pills {
      width: 30vw !important;
    }
    .hearder_left .nav>li {
      padding-left: 1.8vw !important;

      &:first-child {
        padding-left: 0 !important;
      }
    }
    .search-tip .search-btn {
      padding: 0.5vw 0.5vw !important;
      font-size: 0.6vw;

      .iconfangdajingbeifen {
        font-size: 0.8vw;
      }
    }
    .lang {
      font-size: 0.8vw;
    }
    .hearder_left .nav li {
      padding-left: 1vw !important;
    }
    .logo_router {
      float: left;
      z-index: 25;
      width: 16vw;
      background-color: #ffffff;
      margin-top: -10vw;
      padding-top: 10vw;
      position: relative;
    }
  }
</style>

<style>
  .navbar {
    border: 0px solid #fff !important;
  }

  .hearder_left .nav li a {
    padding: 0px 0px !important;
  }


</style>



// WEBPACK FOOTER //
// src/view/index.vue